const renderBlock = (_: any) => {
    return <div>Figma Block</div>;
};

export default renderBlock;
